var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.89 171.78C133.326 171.78 171.78 133.326 171.78 85.89C171.78 38.4543 133.326 0 85.89 0C38.4543 0 0 38.4543 0 85.89C0 133.326 38.4543 171.78 85.89 171.78Z",
    fill: "#32C37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.03 95.03L62.84 122.85L136.75 48.94",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171.78,
    height: 171.78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessful);
export default __webpack_public_path__ + "static/media/payment-successful.7168f66d062151f532bda930b5d12920.svg";
export { ForwardRef as ReactComponent };